( function($) { "use strict";

    var ShopOrderPage = ( function($) {

        ShopOrderPage = function(options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$wa_order_cart = that.$wrapper.find("#js-order-cart");
            that.$commentSection = that.$wrapper.find(".wa-comment-section");

            // VARS
            that.openComment = that.$wrapper.hasClass("s-checkout-order-page-comment-open");

            // DYNAMIC VARS

            // INIT
            that.initClass();
        };

        ShopOrderPage.prototype.initClass = function() {
            var that = this;

            console.log(that.openComment);

            if (that.openComment === true && that.$commentSection.length) {
                $(document).on("wa_order_cart_ready, wa_order_form_reloaded, wa_order_form_changed", function (event, controller) {
                    $("#wa-step-confirm-section").find(".wa-comment-section").addClass("is-opened");
                });
            }

            that.$wrapper.on("click", ".js-clear-cart", function() {
                var wa_order_cart = that.$wa_order_cart.data("controller");
                if (wa_order_cart) {
                    wa_order_cart.clear({
                        confirm: true
                    }).then( function() {
                        location.reload();
                    });
                } else {
                    alert("Error");
                }
            });
        };

        return ShopOrderPage;

    })(jQuery);

    window.ShopOrderPage = ShopOrderPage;

    var $order_page = $("#js-checkout-order-page");
    if ($order_page.length) {
        new window.ShopOrderPage({
            $wrapper: $order_page,
        });
    }

})(jQuery);